// extracted by mini-css-extract-plugin
module.exports = {"ReturnsFormHeader":"styles_ReturnsFormHeader__EbwVK","ReturnsFormHeader__totalItems":"styles_ReturnsFormHeader__totalItems__KWamY"};